import React, { useEffect, useState } from 'react';
import { dowJonesStateApi } from '../apis';
import { SystemWarning } from './SystemWarning';
import { isOnPremise } from '../tracking/environment';
import { useMe } from '../organisation/useMe';

export const SystemWarnings = () => {
  const [showDowJonesWarning, setShowDowJonesWarning] = useState(false);
  useEffect(() => {
    dowJonesStateApi.findState().then((state) => setShowDowJonesWarning(!state.isLastIncrementalUpdateInSafeTimeframe));
  }, []);
  const { isGlobalAdmin } = useMe();

  return (
    <>
      {showDowJonesWarning && (isOnPremise() || isGlobalAdmin) && (
        <SystemWarning>
          Warning: Dow Jones lists may be out of sync. No update has been recorded for at least 24 hours.
        </SystemWarning>
      )}
    </>
  );
};
